// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Badge } from '@gandi/ui';

export type Props = {
  isClosed: boolean,
  isRecommended: boolean,
  isRestricted: boolean,
  onGoing: boolean,
};

function BadgeList({
  isClosed,
  isRecommended,
  isRestricted,
  onGoing,
}: Props): React.Node {
  const { __ } = useTranslator();

  if (!isRecommended && !onGoing && !isRestricted && !isClosed) {
    return null;
  }

  return [
    isRestricted && !isClosed && (
      <Badge key="restricted">{__('restricted')}</Badge>
    ),
    isRecommended && (
      <Badge key="recommended" intent="success">
        {__('recommended')}
      </Badge>
    ),
    onGoing && (
      <Badge key="onGoing" intent="info">
        {__('open')}
      </Badge>
    ),
    isClosed && <Badge key="closed">{__('closed')}</Badge>,
  ];
}

export default BadgeList;
